import React from 'react';
import { TableHead, TableRow, TableCell, Typography } from '@mui/material';

export const MasterTableHead = ({ currHeaders }) => {
  return (
    <TableHead>
      <TableRow>
        {currHeaders.map((currHeader) => {
          return (
            <TableCell
              key={currHeader.key}
              align="center"
              sx={{ minWidth: '250px' }}
            >
              <Typography variant="body1" sx={{ fontWeight: 'bold' }}>
                {currHeader.label}
              </Typography>
            </TableCell>
          );
        })}
        <TableCell align="center" sx={{ minWidth: '100px' }}></TableCell>
      </TableRow>
    </TableHead>
  );
};
